let dialogController = null;

export function registerDialogController(controller) {
  dialogController = controller;
  return () => {
    if (dialogController === controller) {
      dialogController = null;
    }
  };
}

export function notify(message, options = {}) {
  if (dialogController?.notify) {
    return dialogController.notify({ message, ...normalizeOptions(options) });
  }

  if (!isTestEnvironment()) {
    console.info("[Planning notification]", message);
  }

  return null;
}

export function confirmDialog(message, options = {}) {
  if (dialogController?.confirm) {
    return dialogController.confirm({ message, ...normalizeOptions(options) });
  }

  if (!isTestEnvironment()) {
    console.warn("[Planning confirm sans provider]", message);
  }

  return Promise.resolve(false);
}

export function promptDialog(message, defaultValue = "", options = {}) {
  if (dialogController?.prompt) {
    return dialogController.prompt({
      message,
      defaultValue,
      ...normalizeOptions(options),
    });
  }

  if (!isTestEnvironment()) {
    console.warn("[Planning prompt sans provider]", message);
  }

  return Promise.resolve(null);
}

function isTestEnvironment() {
  if (typeof process !== "undefined" && process.env?.NODE_ENV === "test") {
    return true;
  }
  try {
    return import.meta?.env?.MODE === "test";
  } catch {
    return false;
  }
}

function normalizeOptions(options) {
  if (!options || typeof options !== "object") {
    return {};
  }
  return options;
}
